import { ArrowSquareOut, Calendar } from "@phosphor-icons/react";

const BOOKING_URL = "https://thesmilinggoddess.fullslate.com";

export default function Book() {
  return (
    <div className="space-y-8">
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-sage font-bold mb-2">1:1 with Angela</p>
          <h1 className="font-serif text-4xl md:text-5xl font-medium">Book a private session.</h1>
          <p className="text-muted-foreground mt-3 max-w-2xl">
            Step deeper into your journey with a personal 1:1 session — blending intuitive guidance
            with evidence-based coaching to give you the skills, clarity, and focus to live your best life.
          </p>
        </div>
        <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer"
           data-testid="book-open-new-tab"
           className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-border bg-white hover:bg-cream transition-all text-sm">
          Open in new tab <ArrowSquareOut size={14} />
        </a>
      </div>

      <div className="bg-white rounded-3xl border border-border soft-shadow overflow-hidden">
        <div className="px-5 py-3 border-b border-border flex items-center gap-2 text-sm text-muted-foreground">
          <Calendar size={16} weight="duotone" className="text-moss" />
          Powered by Full Slate · thesmilinggoddess.fullslate.com
        </div>
        <iframe
          src={BOOKING_URL}
          title="Book a session with Angela"
          data-testid="book-iframe"
          className="w-full"
          style={{ height: "1200px", border: 0 }}
        />
      </div>
    </div>
  );
}
